import mongoose, { Model, Schema } from 'mongoose';
import { AvailableStatusEnum, IAvailability } from '../interfaces/availability.interface';

const AvailabilitySchema = new Schema<IAvailability>(
    {
        userId: {
            type: Schema.Types.ObjectId,
            required: true,
            ref: 'User',
        },
        startDate: {
            type: Date,
            required: true,
        },
        endDate: {
            type: Date,
            required: true,
        },
        status: {
            type: String,
            enum: Object.values(AvailableStatusEnum),
        },
        // companyName: {
        //     type: String,
        //     trim: true,
        //     required: false,
        // },
        // location: {
        //     type: String,
        //     trim: true,
        //     required: false,
        // },
        jobId: { type: Schema.Types.ObjectId, ref: 'Job' },

        isDeleted: {
            type: Boolean,
            default: false,
        },
        deletedAt: {
            type: Date,
        },
        createdBy: {
            type: Schema.Types.ObjectId,
            ref: 'User',
            required: true,
        },
        updatedBy: {
            type: Schema.Types.ObjectId,
            ref: 'User',
        },
        holidayNotes: { type: String, required: false, default: null }
    },
    {
        timestamps: { createdAt: 'created_at', updatedAt: 'updated_at' },
        versionKey: false,
    }
);

AvailabilitySchema.index({ userId: 1, startDate: 1, endDate: 1 }, { unique: true, partialFilterExpression: { isDeleted: false } });

AvailabilitySchema.pre('save', async function (next) {
    const availability = this as IAvailability;
    if (availability.endDate < availability.startDate) {
        return next(new Error('End date cannot be before start date'));
    }
    next();
});

const Availability: Model<IAvailability> = mongoose.model<IAvailability>('Availability', AvailabilitySchema);
export default Availability;